export default __webpack_public_path__ + "static/media/mat.20aee729.jpeg";